module.exports = __webpack_public_path__ + "img/qash.d38dde49.svg";